// extracted by mini-css-extract-plugin
module.exports = {"modal-box":"kq","modalBox":"kq","modal-mask":"kr","modalMask":"kr","close-btn":"ks","closeBtn":"ks","container":"kt","content":"ku","title":"kv","subTitle":"kw","detail":"kx"};